import { call, put, takeLatest , select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import {
    FETCH_LICENCE,
    SET_LICENCE
} from "../actions";
import initialize from "../auth/initialize";
import {PUT} from "../../api";



const getLicence = (state) => state.licenceValue;



export function* FetchLicenceSaga() {


    const licence = yield select(getLicence);


    let data ={
        license:licence
    }


    try {


        const response = yield call(PUT, `${ApiRouts.API_LICENCE}` , data);



        if (response) {

            yield put({
                type:SET_LICENCE,
                payload:response.data.token
            });
            initialize()
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* licenceSaga() {
    yield takeLatest(FETCH_LICENCE, FetchLicenceSaga);
}

export default licenceSaga;
